import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/play.svg'


const _withScopeId = n => (_pushScopeId("data-v-530abe91"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}, null, -1))
const _hoisted_4 = ["onClick", "src"]
const _hoisted_5 = {
  key: 2,
  class: "photo-author"
}
const _hoisted_6 = { class: "circle" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}, null, -1))
const _hoisted_11 = ["onClick", "src"]
const _hoisted_12 = {
  key: 2,
  class: "photo-author"
}
const _hoisted_13 = { class: "circle" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "no-photo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_splide_slide = _resolveComponent("splide-slide")!
  const _component_splide = _resolveComponent("splide")!
  const _component_drive_files = _resolveComponent("drive-files")!

  return ((_ctx.driveStore.currentCase.photos.length && !_ctx.skeleton) || (_ctx.skeleton || _ctx.photoSkeletonsAmount))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!_ctx.isSwiper)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["photo-container", { 'center': _ctx.driveStore.currentCase.photos.length === 1}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoSkeletonsAmount, (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "photo",
                  key: n
                }, [
                  _createVNode(_component_app_skeleton_rect, { class: "photo-img" })
                ]))
              }), 128)),
              (!_ctx.skeleton)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.driveStore.currentCase.photos, (media) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: media.id,
                      class: "photo"
                    }, [
                      (media.type === _ctx.MEDIA_TYPES.VIDEO)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "video-player",
                            onClick: ($event: any) => (_ctx.selectVideo(media))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.lowResUrlByViewType(media, _ctx.PHOTO_VIEW_TYPE.THUMB),
                              class: "photo-img",
                              alt: "case photo"
                            }, null, 8, _hoisted_2),
                            _hoisted_3
                          ], 8, _hoisted_1))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.selectPhoto(media)),
                            src: _ctx.lowResUrlByViewType(media, _ctx.PHOTO_VIEW_TYPE.HEIGHT),
                            class: "photo-img",
                            alt: "case photo"
                          }, null, 8, _hoisted_4)),
                      (!_ctx.isMyPhoto)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("img", {
                                src: _ctx.photoUrl,
                                alt: ""
                              }, null, 8, _hoisted_7)
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.fullName), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createBlock(_component_splide, {
              key: 1,
              options: { autoWidth: true, fixedHeight: '220px', arrows: false, pagination: false, gap: '1px' }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoSkeletonsAmount, (n) => {
                  return (_openBlock(), _createBlock(_component_splide_slide, {
                    key: n,
                    class: _normalizeClass([{ 'photo-single': _ctx.photoNumbers === 1 }, "photo"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_app_skeleton_rect, { class: "photo-img" })
                    ]),
                    _: 2
                  }, 1032, ["class"]))
                }), 128)),
                (!_ctx.skeleton)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.driveStore.currentCase.photos, (media) => {
                      return (_openBlock(), _createBlock(_component_splide_slide, {
                        key: media.id,
                        class: _normalizeClass(["photo", { 'photo-single': _ctx.driveStore.currentCase.photos.length === 1 }])
                      }, {
                        default: _withCtx(() => [
                          (media.type === _ctx.MEDIA_TYPES.VIDEO)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "video-player",
                                onClick: ($event: any) => (_ctx.selectVideo(media))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.lowResUrlByViewType(media, _ctx.PHOTO_VIEW_TYPE.THUMB),
                                  class: "photo-img",
                                  alt: "case photo"
                                }, null, 8, _hoisted_9),
                                _hoisted_10
                              ], 8, _hoisted_8))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                onClick: ($event: any) => (_ctx.selectPhoto(media)),
                                src: _ctx.lowResUrlByViewType(media, _ctx.PHOTO_VIEW_TYPE.HMED),
                                class: "photo-img",
                                alt: "case photo"
                              }, null, 8, _hoisted_11)),
                          (!_ctx.isMyPhoto)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("img", {
                                    src: _ctx.photoUrl,
                                    alt: ""
                                  }, null, 8, _hoisted_14)
                                ]),
                                _createElementVNode("p", null, _toDisplayString(_ctx.fullName), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
      ], 64))
    : (!_ctx.isNetwork && !_ctx.photoSkeletonsAmount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_drive_files, {
            files: [],
            hideBorder: _ctx.HIDE_BORDER.ALL,
            isPreviewCase: _ctx.isPreviewCase,
            title: "",
            isPhoto: "",
            disabled: _ctx.skeleton
          }, null, 8, ["hideBorder", "isPreviewCase", "disabled"])
        ]))
      : (_ctx.isNetwork)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('shared.case.photos.overview.no.photos')), 1)
          ]))
        : _createCommentVNode("", true)
}